// istanbul ignore file
import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

export interface KpiParameter {
  siteId: string
  assetId: string
  deviceId: string
  parameterType: string
  parameterId: string
}

export interface Stage {
  stageId: number
  operator: string
  calculatedName: string
  kpiParameters: KpiParameter[]
}

export interface CreateCustomKpiRequest {
  kpiName: string
  kpiDescription: string
  isAssetLevel: number
  higherLimitNotification?: string
  lowerLimitNotification?: string
  stage: Stage[]
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: z.optional(z.any()),
  error: z.boolean()
})

export type ApiResponse = z.infer<typeof ZApiResponse>

export async function createCustomKpi (
  createCustomKpiRequest: CreateCustomKpiRequest,
  onSuccess: (successResponse: any, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/kpirest/api/v1/udp/tiq/kpi/createCustomKpi'
  interceptedAxios
    .post(url, createCustomKpiRequest, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data.content[0], parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
